import { PageContainer } from '@/shared/ui/page-container'
import { BasicInfoCard } from './basic-info-card'
import { FormHeader } from './form-header'
import { LocationCard } from './location-card'
import { MediaCard } from './media-card'
import { TranslationsCard } from './translations-card'
import { usePoiForm } from './use-poi-form'

/** Create / edit page of a POI. Rendering only — state and save flows live in `usePoiForm`. */
export function PoiFormPage() {
  const {
    tenantId,
    isEdit,
    isFormReady,
    tenantName,
    language,
    state,
    options,
    imageUpload,
    actions,
    unsavedChangesDialog,
  } = usePoiForm()

  return (
    <PageContainer>
      <FormHeader
        isEdit={isEdit}
        tenantId={tenantId}
        tenantName={tenantName}
        isSaving={actions.isSaving}
        hasUnsavedChanges={state.hasUnsavedChanges}
        onBack={actions.navigateToList}
        onSubmit={() => void actions.handleSubmit()}
      />

      <div className="space-y-6">
        <TranslationsCard
          isEdit={isEdit}
          isFormReady={isFormReady}
          translations={state.translations}
          onChange={state.setTranslations}
          entityId={state.translationEntityId}
          initialLanguage={language.formLanguageCode}
          runningJobCount={state.pendingSuccessJobs.length}
          isSaving={actions.savingSection === 'translations'}
          isSaveDisabled={actions.isBusy}
          onSave={() => void actions.handleSaveTranslations()}
        />

        <div className="grid gap-6 xl:grid-cols-[minmax(0,1.55fr)_minmax(360px,0.95fr)]">
          <LocationCard
            isEdit={isEdit}
            isFormReady={isFormReady}
            location={state.location}
            onChange={state.handleLocationChange}
            destination={options.selectedDestination}
            destinationCenter={options.destinationCenter}
            isDirty={state.isLocationDirty}
            isSaving={actions.savingSection === 'location'}
            isSaveBlocked={actions.isBusy}
            onSave={() => void actions.handleSaveLocation()}
          />

          <div className="space-y-6">
            <BasicInfoCard
              isEdit={isEdit}
              isFormReady={isFormReady}
              tenantId={tenantId}
              languageCode={language.formLanguageCode}
              basicInfo={state.basicInfo}
              onBasicInfoChange={state.handleBasicInfoChange}
              tenantDestinationId={state.tenantDestinationId}
              onDestinationChange={state.selectDestination}
              destinations={options.destinations}
              isDestinationsLoading={options.isDestinationsLoading}
              selectedDestination={options.selectedDestination}
              categoryOptions={options.categoryOptions}
              typeOptions={options.typeOptions}
              categoriesQuery={options.categoriesQuery}
              onCreateDestination={actions.handleCreateDestinationNavigation}
              onCreateCategory={actions.handleCreateCategoryNavigation}
              isActive={state.isActive}
              onActiveChange={state.setIsActive}
              isDirty={state.isBasicInfoDirty}
              isSaving={actions.savingSection === 'basicInfo'}
              isSaveBlocked={actions.isBusy}
              onSave={() => void actions.handleSaveBasicInfo()}
            />

            <MediaCard
              isEdit={isEdit}
              isFormReady={isFormReady}
              images={state.images}
              onChange={state.setImages}
              onFilesSelected={imageUpload.handleSelectedImages}
              isDirty={state.isMediaDirty}
              isSaving={actions.savingSection === 'media'}
              isSaveBlocked={actions.isBusy || actions.isUploadingImages}
              onSave={() => void actions.handleSaveMedia()}
            />
          </div>
        </div>
      </div>
      {unsavedChangesDialog}
    </PageContainer>
  )
}
